import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-cafe-brown text-white">
      <div className="container-custom">
        <div className="py-6 sm:py-8 md:py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 px-3 sm:px-4">
            {/* Cafe Info */}
            <div className="text-center md:text-left">
              <div className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 font-serif">
                <span className="text-cafe-gold">Manaslu</span> Cafe
              </div>
              <p className="text-sm sm:text-base text-cafe-cream mb-4 leading-relaxed">
                Fresh, Quality Food from the Heart of Woodside, Queens. We specialize in bringing 
                prime breakfasts, tasty lunches, and delicious dinners using only the 
                freshest ingredients.
              </p>
              <div className="flex space-x-3 sm:space-x-4 justify-center md:justify-start">
                <a
                  href="https://www.facebook.com/Manaslucafe/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 sm:w-10 sm:h-10 bg-cafe-gold rounded-lg flex items-center justify-center text-cafe-brown hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105"
                  aria-label="Follow us on Facebook"
                >
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/manaslucafe?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 sm:w-10 sm:h-10 bg-cafe-gold rounded-lg flex items-center justify-center text-cafe-brown hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105"
                  aria-label="Follow us on Instagram"
                >
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a
                  href="https://www.tiktok.com/@manaslu.g.llc?is_from_webapp=1&sender_device=pc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 sm:w-10 sm:h-10 bg-cafe-gold rounded-lg flex items-center justify-center text-cafe-brown hover:bg-opacity-90 transition-all duration-300 transform hover:scale-105"
                  aria-label="Follow us on TikTok"
                >
                  <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="text-center md:text-left">
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 font-serif">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="#home"
                    className="text-sm sm:text-base text-cafe-cream hover:text-cafe-gold transition-colors duration-300"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#menu"
                    className="text-sm sm:text-base text-cafe-cream hover:text-cafe-gold transition-colors duration-300"
                  >
                    Menu
                  </a>
                </li>
                <li>
                  <a
                    href="#gallery"
                    className="text-sm sm:text-base text-cafe-cream hover:text-cafe-gold transition-colors duration-300"
                  >
                    Gallery
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    className="text-sm sm:text-base text-cafe-cream hover:text-cafe-gold transition-colors duration-300"
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="text-center md:text-left">
              <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 font-serif">Contact Info</h3>
              <div className="space-y-3 text-cafe-cream">
                <div className="flex items-start space-x-3 justify-center md:justify-start">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 mt-1 text-cafe-gold flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <div className="text-sm sm:text-base">
                    <p>3906 1/2 64th St, Woodside, NY 11377, United States</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3 justify-center md:justify-start">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-cafe-gold flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <p className="text-sm sm:text-base">+1 347-527-1202</p>
                </div>
                <div className="flex items-center space-x-3 justify-center md:justify-start">
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-cafe-gold flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <p className="text-sm sm:text-base">manaslucafe@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-cafe-gold border-opacity-30 py-4 sm:py-6 px-3 sm:px-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
            <p className="text-cafe-cream text-xs sm:text-sm mb-3 md:mb-0">
              © {currentYear} Manaslu Cafe. All rights reserved.
            </p>
            <div className="flex space-x-4 sm:space-x-6 text-xs sm:text-sm">
              <a href="/privacy-policy" className="text-cafe-cream hover:text-cafe-gold transition-colors duration-300">
                Privacy Policy
              </a>
              <a href="/terms-of-service" className="text-cafe-cream hover:text-cafe-gold transition-colors duration-300">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
